import fr from './fr.json'
import en from './en.json'
import it from './it.json'
import de from './de.json'
import es from './es.json'

export default {
  fr: { translation: fr, stime: fr.stime },
  en: { translation: en, stime: en.stime },
  it: { translation: it, stime: it.stime },
  de: { translation: de, stime: de.stime },
  es: { translation: es, stime: es.stime },
}
